// fw PersonRow — the dispatch .drow: avatar, name/meta, right-aligned
// trailing (elapsed, condensed tabular).

import React from 'react';
import { Avatar } from './Avatar.js';
import './PersonRow.css';

export function PersonRow({ initials, name, meta, trailing, tone = 'neutral', onClick, className = '', ...rest }) {
  const cls = ['fw-person', onClick ? 'fw-person--tappable' : '', className].filter(Boolean).join(' ');
  const inner = (
    <>
      <Avatar initials={initials} tone={tone} />
      <span className="fw-person__text">
        <span className="fw-person__name">{name}</span>
        {meta ? <span className="fw-person__meta">{meta}</span> : null}
      </span>
      {trailing !== undefined && trailing !== null ? (
        <span className="fw-person__trailing fw-num">{trailing}</span>
      ) : null}
    </>
  );
  if (onClick) {
    return (
      <button type="button" className={cls} data-tone={tone} onClick={onClick} {...rest}>
        {inner}
      </button>
    );
  }
  return (
    <div className={cls} data-tone={tone} {...rest}>
      {inner}
    </div>
  );
}

export default PersonRow;
